const mutations = {
    setUser: (state, payload) => {
        state.user = payload;
    },
    
};

export default mutations;
